import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  RoleDto,
  SubscriptionLevel,
  UserDto,
} from "../../autogenerated/models";
import {
  fetchRoles,
  fetchSubscribers,
  setSubscriptionLevel,
  setUnshacledSubscriptionLevel,
  toggleRoleForUser,
} from "../api";

export interface AdministrationState {
  isLoading: boolean;
  isRefreshing: boolean;
  page: number;
  users: UserDto[];
  roles: RoleDto[];
}

const initialState: AdministrationState = {
  isLoading: false,
  isRefreshing: false,
  page: 0,
  users: [],
  roles: [],
};

export const administrationSlice = createSlice({
  name: "administration",
  initialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsRefreshing: (state, action) => {
      state.isRefreshing = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    setUserRoles: (state, action: PayloadAction<UserDto>) => {
      let index = state.users.findIndex((u) => u.id === action.payload.id);
      if (index !== -1) state.users[index].roles = action.payload.roles;
    },
    setUserSubscription: (state, action: PayloadAction<UserDto>) => {
      let index = state.users.findIndex((u) => u.id === action.payload.id);
      if (index !== -1)
        state.users[index].subscription = action.payload.subscription;
    },
    setUserUnshacledSubscription: (state, action: PayloadAction<UserDto>) => {
      let index = state.users.findIndex((u) => u.id === action.payload.id);
      if (index !== -1)
        state.users[index].unshacledSubscription = action.payload.unshacledSubscription;
    },
    setRoles: (state, action) => {
      state.roles = action.payload;
    },
  },
});

export const { actions } = administrationSlice;

export const getSubscribers = (pageNumber: number) => {
  return (dispatch: any) => {
    dispatch(actions.setIsLoading(true));
    dispatch(actions.setPage(pageNumber));
    return fetchSubscribers(pageNumber)
      .then((users) => {
        dispatch(actions.setUsers(users));
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => dispatch(actions.setIsLoading(false)));
  };
};

export const getInitialRolasAndSubscribers = () => {
  return (dispatch: any) => {
    dispatch(actions.setIsLoading(true));

    return fetchRoles()
      .then((roles) => {
        dispatch(actions.setRoles(roles));
      })
      .then(() => {
        fetchSubscribers(0)
          .then((users) => {
            dispatch(actions.setUsers(users));
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => dispatch(actions.setIsLoading(false)));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const toggleRole = (userId: string, roleId: string) => {
  return (dispatch: any) => {
    dispatch(actions.setIsRefreshing(true));
    return toggleRoleForUser(userId, roleId)
      .then((user) => {
        dispatch(actions.setUserRoles(user));
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => dispatch(actions.setIsRefreshing(false)));
  };
};

export const setSubscription = (
  veracityId: string,
  subscription: SubscriptionLevel
) => {
  return (dispatch: any) => {
    dispatch(actions.setIsRefreshing(true));
    return setSubscriptionLevel(veracityId, subscription)
      .then((user: UserDto) => {
        dispatch(actions.setUserSubscription(user));
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => dispatch(actions.setIsRefreshing(false)));
  };
};

export const setUnshacledSubscription = (
  veracityId: string,
  subscription: SubscriptionLevel
) => {
  return (dispatch: any) => {
    dispatch(actions.setIsRefreshing(true));
    return setUnshacledSubscriptionLevel(veracityId, subscription)
      .then((user: UserDto) => {
        dispatch(actions.setUserUnshacledSubscription(user));
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => dispatch(actions.setIsRefreshing(false)));
  };
};
